import * as React from "react";
import { Icon, IconButton } from "@chakra-ui/react";
import { IconType } from "react-icons/lib";
import { useSlate } from "slate-react";
import { MarkFormat } from "../../../../duck";
import { checkIsMarkActive, toggleMark, restoreSelection } from "../../duck";

interface MarkButtonProps {
  mark: MarkFormat;
  title: string;
  icon: IconType;
}

const MarkButton: React.FC<MarkButtonProps> = ({ mark, icon, title }) => {
  const editor = useSlate();

  return (
    <IconButton
      size="sm"
      colorScheme="gray"
      icon={<Icon as={icon} />}
      title={title}
      aria-label={title}
      onClick={event => {
        event.preventDefault();
        toggleMark(editor, mark);
        restoreSelection(editor);
      }}
      variant={checkIsMarkActive(editor, mark) ? undefined : "ghost"}
    />
  );
};

export default MarkButton;
